module.exports = __webpack_public_path__ + "img/lu.3ba095e9.svg";